<template>
  <div class="section">
    <div class="content">
      <h1 :aria-label="$t('privacy.dataprotection.Title')" class="title">
        {{ $t("privacy.dataprotection.Title") }}
      </h1>
      <p
        class="content"
        v-for="(text, index) in $t('privacy.dataprotection.content')"
        :aria-label="text"
      >
        {{ text }}
      </p>
      <h2 :aria-label="$t('privacy.contactus.Title')">
        {{ $t("privacy.contactus.Title") }}
      </h2>
      <p
        class="content"
        v-for="(text, index) in $t('privacy.contactus.content')"
        :aria-label="text"
      >
        {{ text }}
      </p>
      <h2 :aria-label="$t('privacy.cookies.Title')">
        {{ $t("privacy.cookies.Title") }}
      </h2>
      <p
        class="content"
        v-for="(text, index) in $t('privacy.cookies.content')"
        :aria-label="text"
      >
        {{ text }}
      </p>
      <h2 :aria-label="$t('privacy.webanalysis.Title')">{{ $t("privacy.webanalysis.Title") }}</h2>
      <p
        class="content"
        v-for="(text, index) in $t('privacy.webanalysis.content')"
        :aria-label="text"
      >
        {{ text }}
      </p>
      <h2 :aria-label="$t('privacy.yourrights.Title')">{{ $t("privacy.yourrights.Title") }}</h2>
      <p
        class="content"
        v-for="(text, index) in $t('privacy.yourrights.content')"
        :aria-label="text"
      >
        {{ text }}
      </p>
      <address>
        <strong>{{ $t("privacy.contact.title") }}</strong
        ><br />
        <span
          class="content"
          v-for="(text, index) in $t('privacy.contact.adress')"
          :aria-label="text"
        >
          {{ text }}
          <br />
        </span>
        <a v-bind:href="$t('privacy.contact.link')">{{
          $t("privacy.contact.link")
        }}</a>
        <br />
        <a v-bind:href="'mailto:' + $t('privacy.contact.mail')">{{
          $t("privacy.contact.mail")
        }}</a>
        <br />
        <span
          class="content"
          v-for="(text, index) in $t('privacy.contact.vat')"
          :aria-label="text"
        >
          {{ text }}
          <br />
        </span>
      </address>
      <!-- <Contact /> -->
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Contact.vue";

export default {
  components: { Contact },
};
</script>
